import { Divider, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import FormCheckbox from '@Components/Form/FormCheckBox';
import { defaultCompletedSection } from '@Domains/utils';
import { formatToShortThaiDateTime } from '@Utils/datetime';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IGreenhouseGoalTermFormValues } from '../EsgGreenhouseFormProvider/types';
import {
  checkCarbonEnValid,
  checkCarbonThValid,
  checkGhGoalEnValid,
  checkGhGoalTermComplete,
  checkGhGoalTermEnValid,
  checkGhOtherEnValid,
  checkGhOtherThValid,
  checkIntroRemarkValid,
  checkNetZeroEnValid,
  checkNetZeroThValid,
} from './utils';
import { resetCompletedSection } from '@Utils/updateCompletedSection';
import { useFormContext } from 'react-hook-form';

const GreenhouseGoalTermCompletedCheckbox = () => {
  const { watch } = useGreenhouseForm();
  const { isPublished } = useProgressBar();
  const greenhouseGoalTerm = watch(
    'greenhouseGoalTerm'
  ) as IGreenhouseGoalTermFormValues;
  const { setValue } = useFormContext();

  const { greenhouseGoal, netZero, carbon, other } = greenhouseGoalTerm || {};

  const completedSection =
    greenhouseGoalTerm?.completedSection || defaultCompletedSection;

  const {
    isCompletedTh,
    isCompletedEn,
    dateTh,
    dateEn,
    roleStampTh,
    roleStampEn,
  } = completedSection;

  const formattedCompletedSectionDateTh = dateTh
    ? formatToShortThaiDateTime(dateTh)
    : '';
  const formattedCompletedSectionDateEn = dateEn
    ? formatToShortThaiDateTime(dateEn)
    : '';

  const isCompleteTh =
    checkGhGoalTermComplete(greenhouseGoalTerm) &&
    checkIntroRemarkValid(greenhouseGoalTerm) &&
    checkNetZeroThValid(netZero) &&
    checkCarbonThValid(carbon) &&
    checkGhOtherThValid(other);

  const isCompleteEn =
    checkGhGoalTermComplete(greenhouseGoalTerm) &&
    checkGhGoalTermEnValid(greenhouseGoalTerm) &&
    checkGhGoalEnValid(greenhouseGoal) &&
    checkNetZeroEnValid(netZero) &&
    checkCarbonEnValid(carbon) &&
    checkGhOtherEnValid(other);

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    language: 'Th' | 'En'
  ) => {
    const updatedSection = { ...completedSection };

    if (language === 'Th') {
      updatedSection.isCompletedTh = e.target.checked;
    } else {
      updatedSection.isCompletedEn = e.target.checked;
    }

    resetCompletedSection(updatedSection, setValue, 'greenhouseGoalTerm');
  };

  return (
    <>
      <Divider />
      <Flex gap={4} justifyContent={'center'} bgcolor={'grey.50'} py={1}>
        <Flex alignItems={'center'}>
          <Typography fontWeight={800} textAlign={'right'}>
            ยืนยันการตรวจสอบข้อมูลครบถ้วน
          </Typography>
        </Flex>
        <Flex>
          <Flex flexDirection="column" alignItems={'center'}>
            <FormCheckbox
              name="greenhouseGoalTerm.completedSection.isCompletedTh"
              label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาไทย)"
              inputProps={{ disabled: isPublished || !isCompleteTh }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleCheckboxChange(e, 'Th')
              }
            />
            {isCompletedTh && dateTh && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ display: 'block' }}
              >
                โดย {roleStampTh} {formattedCompletedSectionDateTh}
              </Typography>
            )}
          </Flex>

          <Flex flexDirection="column" alignItems={'center'}>
            <FormCheckbox
              sx={{ ml: 2 }}
              name="greenhouseGoalTerm.completedSection.isCompletedEn"
              label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาอังกฤษ)"
              inputProps={{ disabled: isPublished || !isCompleteEn }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleCheckboxChange(e, 'En')
              }
            />
            {isCompletedEn && dateEn && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ display: 'block' }}
              >
                โดย {roleStampEn} {formattedCompletedSectionDateEn}
              </Typography>
            )}
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default GreenhouseGoalTermCompletedCheckbox;
